import React, { Component } from "react";
import { Link } from "@reach/router";
import { getConfigParamsTemplateName } from '../../services/helpers'
class CustomerProjects extends Component {

  renderProjectRows(projects) {
    return (
      projects &&
      projects.map((project) => (
        <tr key={project._id}>
          <td>{project.name}</td>
          <td>{getConfigParamsTemplateName(project, this.props.configParams)}</td>
          <td>
            <Link to={`/customer/${this.props.accountId}/project/${project._id}`}>
              EDIT
            </Link>
          </td>
        </tr>
      ))
    );
  }

  render = () => {
    return (
      <div>
        <label className="box-label">Projects</label>
        <table className="customer-projects-table">
          <thead>
            <tr>
              <th>Name</th>
              <th>SDK Remote Config</th>
              <th></th>
            </tr>
          </thead>
          <tbody>{this.renderProjectRows(this.props.projects)}</tbody>
        </table>
      </div>
    ); // return
  }; // render
} // CustomerProjects

export default CustomerProjects;
